import { OAuth2Config } from '../types';
import { AuthorizationUrlStrategy } from './authorization-url.strategy';

export class StandardAuthorizationUrlStrategy implements AuthorizationUrlStrategy {
  protected buildUrlParams(params: Record<string, string | undefined>): string {
    const filtered = Object.entries(params)
      .filter(([, value]) => value !== undefined)

      .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`);

    return filtered.join('&');
  }

  generateAuthorizationUrl(config: OAuth2Config, state: string, codeChallenge?: string): string {
    const params: Record<string, string | undefined> = {
      client_id: config.clientId,
      redirect_uri: config.redirectUri,
      response_type: 'code',
      scope: config.scopes.join(' '),
      state,
    };

    // Add PKCE parameters
    if ((config.usePKCE || config.pkce) && codeChallenge) {
      params.code_challenge = codeChallenge;
      params.code_challenge_method = 'S256';
    }

    // Merge additional parameters (for both additionalParams and extraAuthParams)
    const extraParams = {
      ...config.additionalParams,
      ...config.extraAuthParams,
    };

    Object.assign(params, extraParams);

    return `${config.authorizationUrl}?${this.buildUrlParams(params)}`;
  }
}
